module.exports = __webpack_public_path__ + "static/media/cdk_4bhk_pent.6360e585.jpg";